import React from 'react';
import { NewsletterEmbed } from './NewsletterEmbed';
export function HomeNewsletterSignup() {
  return <section aria-labelledby="home-newsletter-heading" className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-120" data-mp="1r1gsyvinpdku">
      <div className="max-w-4xl mx-auto" data-id="element-121" data-mp="1n295p3i19jat">
        <h2 id="home-newsletter-heading" className="text-xl md:text-2xl font-bold text-brand-navy mb-3" data-id="element-122" data-mp="1i1tryatua9sb">
          Not ready to talk yet?
        </h2>
        <p className="text-base md:text-lg text-brand-gray leading-relaxed mb-6" data-id="element-123" data-mp="2apzd2yot20so">
          Get Broken Pencils, my newsletter on AI transformation and leadership,
          every other week.
        </p>
        <div className="w-full max-w-[480px] mx-auto" data-id="element-124" data-mp="21060bucxffmu">
          <NewsletterEmbed data-id="element-125" data-mp="20znxufzo856h" />
        </div>
      </div>
    </section>;
}